/*
*  connection of the form for create medical questionnaire
*/

import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'
import serializer from 'form-serializer'
import mask from 'jquery-mask-plugin'
import datetimepicker from 'jquery-datetimepicker'
import "smartwizard/dist/css/smart_wizard_all.css"
import smartWizard from 'smartwizard'
import {Modal} from "bootstrap"
import {resolveWebpackURL} from "workbox-webpack-plugin/build/lib/resolve-webpack-url";

export default class extends Controller {
    static targets = [ "id"]
    WhoIs;
    receiptGlassCounter = 0;
    receiptGlassCounterGen = 0;

    initialize() {
        super.initialize();

    }

    //check authorization
    checkToken(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
            if(this.WhoIs.status === 500) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                let nameVar = Twig.twig({ref: "authorization"}).render({});
                $('#authorization').html(nameVar)
            }
        } else {
            sessionStorage.removeItem('userId');
            let nameVar = Twig.twig({ref: "authorization"}).render({});
            $('#authorization').html(nameVar)
        }
    }


   //looking for a client in the WEB database
    search(){
        this.checkToken();
        let phone = $('#clientPhone').val().replace(/\D/g, "");
        if (phone.length < 11){
            return
        }
        let result = api.searchClient(phone);
        console.debug(result);

        if(result.status !== 200) {
            alert('Не получены данные из WEB. Повторите попытку позже.');
            this.goToDatabase();
        }
        if (result.length === 0) {
            const myModal = new Modal('#createPatientModal');
            myModal.show();
            $('#newClientPhone').val($('#clientPhone').val()).attr({
                disabled: false,
                required: true,
                readonly: true
            });
            $('#newClientName').attr({
                disabled: false,
                required: true
            });
            $('#newClientSurname').attr({
                disabled: false,
                required: true
            });
            $('#newClientBtn').attr({
                disabled: false
            });
        } else  {
            let phone = (result[0].CepTel);
            let phoneInput = $('#clientPhone');
            phoneInput.val(phoneInput.masked(phone));
            $('#clientName').val(result[0].CariAd);
            $('#clientSurname').val(result[0].CariSoyad);
            if (result[0].DogTar !== ''){
                let clientDateBirth = new Date(result[0].DogTar).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
                $('#clientDateBirth').val(clientDateBirth);
                this.clientAge();
            }
            let phoneBase = phone.replace(/\D/g, "");
            let ourUser = api.getByPhone(phoneBase);
            if (ourUser !== null){
                $('#doctorName').after('<input type="hidden" name="patientId" value="' + ourUser.ID + '">')
            }
        }
    }

    //count 180 days (6 months x 30 days) from the current date
    nextAppointmentDateVal(){
        if($('#nextAppointmentDate').val() === ''){
                let days180 =  new Date(new Date().setDate(new Date().getDate() + 180));
                $('#nextAppointmentDate').val(days180.toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" }));
        }
    }

    // create a client. result = First name, last name, phone number, ID
    createClient(phone, name, surname){
        this.checkToken();
        let phoneClient = $('#newClientPhone').val().replace(/\D/g, "");
        let nameClient = $('#newClientName').val();
        let surnameClient = $('#newClientSurname').val();
        let result = api.createClient(phoneClient, nameClient, surnameClient);
       /* console.debug(result);*/
        this.createClientNo();
        $('#clientPhone').val(result.CepTel).attr('readonly', true);
        $('#clientName').val(result.CariAd).attr('readonly', true);
        $('#clientSurname').val(result.CariSoyad).attr('readonly', true);
    }

    //if I just close the modal without saving
    createClientNo(){
        $('#newClientPhone').val($('#clientPhone').val()).attr({
            disabled: true,
            required: false,
            readonly: false
        });
        $('#newClientName').attr({
            disabled: true,
            required: false,
        });
        $('#newClientSurname').attr({
            disabled: true,
            required: false,
        });

        $('#newClientBtn').attr({
            disabled: true
        });
    }

    //fill out the patient questionnaire
    async fillForm(){
        this.checkToken();
        console.log('fillForm')
        let formUserId = $('#form-creation').attr('data-form');
        $('input[type="checkbox"][value="noData"]').attr('checked', false);

        try{
            //pull out the profile by ID
            let userFormData = api.getAnketa(formUserId);
            console.debug(userFormData);
            console.debug(userFormData.ReceiptGlass[0]);
            $('#doctorName').after('' +
                '<input type="hidden" name="patientId" value="' + userFormData.PatientID + '">');

            //set values
            $('#clientName').val(userFormData.ClientName);
            $('#clientSurname').val(userFormData.ClientSurname);

            //birthday
            let ClientDateBirth = new Date(userFormData.ClientDateBirth).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
            $('#clientDateBirth').val(ClientDateBirth);

            $('#clientAge').val(userFormData.ClientAge);


            //first visit
            let clientFirstRequest = new Date(userFormData.ClientFirstRequest).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
            $('#clientFirstRequest').val(clientFirstRequest);

            $('#clientPhone').val(userFormData.Phone);
            $('#clientSymptomsDescription').val(userFormData.ClientSymptomsDescription);
            $('#clientDoWithoutGlasses').val(userFormData.ClientDoWithoutGlasses);
            $('#clientProfession').val(userFormData.ClientProfession);

            if(userFormData.NextAppointmentDate !== null){
                let dateNextAppointment = new Date(userFormData.NextAppointmentDate);
                let dayNextAppointment = dateNextAppointment.getDate();
                let monthNextAppointment = dateNextAppointment.getMonth() + 1;
                if(dayNextAppointment < 10) {
                    dayNextAppointment = '0' + dayNextAppointment
                }
                if(monthNextAppointment < 10) {
                    monthNextAppointment = '0' + monthNextAppointment
                }
                let anketaNextAppointment = dayNextAppointment + '.' + monthNextAppointment + '.' + dateNextAppointment.getFullYear();
                $('#nextAppointmentDate').val(anketaNextAppointment);

            }

            //next visit
            // let NextAppointmentDate = new Date(userFormData.NextAppointmentDate).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
            // $('#NextAppointmentDate').val(NextAppointmentDate);

            let howFindUs = userFormData.HowFindUs;
            howFindUs.forEach((item)=>{
                $('.howFind-validation__box input[value="' + item +'"]').prop('checked', true)
            });

            let visualLoads = userFormData.VisualLoadsList;
            visualLoads.forEach((item)=>{
                $('.visualLoads-validation__box input[value="' + item +'"]').prop('checked', true)
            });

            let improveVision = userFormData.ImproveVisionList;
            improveVision.forEach((item)=>{
                $('.improveVision-validation__box input[value="' + item +'"]').prop('checked', true)
            });

            //previous Glasses - yes/no choice
            let previousGlassesList = userFormData.PreviousGlassesList;
            $('input[name="previousGlassesList"][value="'+previousGlassesList+'"]').prop('checked', true).addClass('checked');
            if (previousGlassesList === 'noGlass' || previousGlassesList === 'noData'){
                $('.noGlass textarea, .noGlass select, .noGlass input').attr('disabled', true);
                $('.noGlass').addClass('disabled-box');
            } else {
                $('.noGlass textarea, .noGlass select, .noGlass input').attr('disabled', false);
                $('.noGlass').removeClass('disabled-box');
            }


            // previous Glasses - table. fields are optional, check for null
            let previousGlasses = userFormData.PreviousGlasses;
            if(previousGlasses !== null){
                $('.noGlass .previousGlasses-sph-r').val(previousGlasses.r.sph);
                $('.noGlass .previousGlasses-cyl-r').val(previousGlasses.r.cyl);
                $('.noGlass .previousGlasses-ax-r').val(previousGlasses.r.ax);
                $('.noGlass .previousGlasses-pr-r').val(previousGlasses.r.pr);
                $('.noGlass .previousGlasses-bas-r').val(previousGlasses.r.bas);
                $('.noGlass .previousGlasses-add-r').val(previousGlasses.r.add);
                $('.noGlass .previousGlasses-rc-r').val(previousGlasses.r.rc);
                $('.noGlass .previousGlasses-vis-r').val(previousGlasses.r.vis);
                $('.noGlass .previousGlasses-sph-l').val(previousGlasses.l.sph);
                $('.noGlass .previousGlasses-cyl-l').val(previousGlasses.l.cyl);
                $('.noGlass .previousGlasses-ax-l').val(previousGlasses.l.ax);
                $('.noGlass .previousGlasses-pr-l').val(previousGlasses.l.pr);
                $('.noGlass .previousGlasses-bas-l').val(previousGlasses.l.bas);
                $('.noGlass .previousGlasses-add-l').val(previousGlasses.l.add);
                $('.noGlass .previousGlasses-rc-l').val(previousGlasses.l.rc);
                $('.noGlass .previousGlasses-vis-l').val(previousGlasses.l.vis);
            }

            // previous Glasses - textarea - fields are optional, check for null
            if(userFormData.LandFeatures !== null){
                $('#clientOldGlasses').val(userFormData.LandFeatures);
            }


            //previous contact lens  - sampling radio
            let previousLensType = userFormData.PreviousLensType;
            $('#previousLensType-box input[value="'+previousLensType+'"]').prop('checked', true).addClass('checked');
            if (previousLensType === 'noLens' || previousLensType === 'noData'){
                $('.noLens input').attr('disabled', true);
                $('.noLens').addClass('disabled-box');
            } else {
                $('.noLens input').attr('disabled', false);
                $('.noLens').removeClass('disabled-box');
            }
            //previous contact lenses - table. fields are optional, check for null
            let PreviousLens = userFormData.PreviousLens;
            if(PreviousLens !== null){
                $('input[list="previousLensOD-sph"]').val(userFormData.PreviousLens.OD.sph);
                $('input[list="previousLensOD-cyl"]').val(userFormData.PreviousLens.OD.cyl);
                $('input[list="previousLensOD-ax"]').val(userFormData.PreviousLens.OD.ax);
                $('input[list="previousLensOD-add"]').val(userFormData.PreviousLens.OD.add);
                $('input[id="previousLensOD-bc"]').val(userFormData.PreviousLens.OD.bc);
                $('input[id="previousLensOD-dia"]').val(userFormData.PreviousLens.OD.dia);
                $('input[list="previousLensOS-sph"]').val(userFormData.PreviousLens.OS.sph);
                $('input[list="previousLensOS-cyl"]').val(userFormData.PreviousLens.OS.cyl);
                $('input[list="previousLensOS-ax"]').val(userFormData.PreviousLens.OS.ax);
                $('input[list="previousLensOS-add"]').val(userFormData.PreviousLens.OS.add);
                $('input[id="previousLensOS-bc"]').val(userFormData.PreviousLens.OS.bc);
                $('input[id="previousLensOS-dia"]').val(userFormData.PreviousLens.OS.dia);
            }


            //symptomatic complaints
            let symptomaticComplaints = userFormData.SymptomaticComplaints;
            if(symptomaticComplaints.headaches !== ""){
                $('#symptomaticComplaints-headaches').attr('checked', true);
                $('#symptomaticComplaints-headaches-list input').attr('disabled', false);
                $('#symptomaticComplaints-headaches-list input[value="'+ symptomaticComplaints.headaches +'"]').prop('checked', true);
            }

            if(symptomaticComplaints.brightLight !== ""){
                $('#symptomaticComplaints-brightLight').attr('checked', true);
                $('#symptomaticComplaints-brightLight-list input').attr('disabled', false);
                $('#symptomaticComplaints-brightLight-list input[value="'+ symptomaticComplaints.brightLight +'"]').prop('checked', true);
            }
            if(symptomaticComplaints.focus !== ""){
                $('#symptomaticComplaints-focus').attr('checked', true);
                $('#symptomaticComplaints-focus-list input').attr('disabled', false);
                $('#symptomaticComplaints-focus-list input[value="'+ symptomaticComplaints.focus +'"]').prop('checked', true);
            }
            if(symptomaticComplaints.noClarity !== ""){
                $('#symptomaticComplaints-noClarity').attr('checked', true);
                $('#symptomaticComplaints-noClarity-list input').attr('disabled', false);
                $('#symptomaticComplaints-noClarity-list input[value="'+ symptomaticComplaints.noClarity +'"]').prop('checked', true);
            }
            if(symptomaticComplaints.twilight !== ""){
                $('#symptomaticComplaints-twilight').attr('checked', true);
                $('#symptomaticComplaints-twilight-list input').attr('disabled', false);
                $('#symptomaticComplaints-twilight-list input[value="'+ symptomaticComplaints.twilight +'"]').prop('checked', true);
            }
            if(symptomaticComplaints.redness !== ""){
                $('#symptomaticComplaints-redness').attr('checked', true);
                $('#symptomaticComplaints-redness-list input').attr('disabled', false);
                $('#symptomaticComplaints-redness-list input[value="'+ symptomaticComplaints.redness +'"]').prop('checked', true);
            }

            if(symptomaticComplaints.close !== ""){
                $('#symptomaticComplaints-close').attr('checked', true);
                $('#symptomaticComplaints-close-list input').attr('disabled', false);
                $('#symptomaticComplaints-close-list input[value="'+ symptomaticComplaints.close +'"]').prop('checked', true);
            }

            // diseases, operations, medicines, accounting
            $('#clientEyeSurgeries').val(userFormData.ClientEyeSurgeries);
            $('#clientChronic').val(userFormData.ClientChronic);
            $('#clientMedications').val(userFormData.ClientMedications);
            $('#clientOphthalmologist').val(userFormData.ClientOphthalmologist);
            $('#clientExamination').val(userFormData.ClientExamination);


            //Autorefractometry table
            $('input[list="autorefractometry-OSax"]').val(userFormData.Autorefractometry.OS.ax);
            $('input[list="autorefractometry-OSSph"]').val(userFormData.Autorefractometry.OS.sph);
            $('input[list="autorefractometry-OScyl"]').val(userFormData.Autorefractometry.OS.cyl);
            $('input[list="autorefractometry-ODax"]').val(userFormData.Autorefractometry.OD.ax);
            $('input[list="autorefractometry-ODSph"]').val(userFormData.Autorefractometry.OD.sph);
            $('input[list="autorefractometry-ODcyl"]').val(userFormData.Autorefractometry.OD.cyl);

            //Keratometry table
            $('input[list="keratometry-ODcyl"]').val(userFormData.Keratometry.OD.cyl);
            $('input[list="keratometry-ODax"]').val(userFormData.Keratometry.OD.ax);
            $('input[list="keratometry-OScyl"]').val(userFormData.Keratometry.OS.cyl);
            $('input[list="keratometry-OSax"]').val(userFormData.Keratometry.OS.ax);


            //Cover test into the distance
            let preliminaryTestDistance = userFormData.PreliminaryTest.distanse;
            preliminaryTestDistance.forEach((item)=>{
                $('.preliminaryTestDistanse-validation__box input[value="' + item +'"]').prop('checked', true)
            });

            //Cover test up close
            let preliminaryTestNear = userFormData.PreliminaryTest.near;
            if(preliminaryTestNear !== undefined){
                preliminaryTestNear.forEach((item)=>{
                    $('.preliminaryTestNear-validation__box input[value="' + item +'"]').prop('checked', true)
                });
            }


            //Hirschberg deviation table
            $('input[list="girshberg-OD"]').val(userFormData.Girshberg.OD);
            $('input[list="girshberg-OS"]').val(userFormData.Girshberg.OS);

            //Mobility of the eyeballs
            if(userFormData.MobilityEyeballsLimitationMuscles === null && userFormData.MobilityEyeballsNerveParesis === null) {
                $('#mobilityEyeballs-full').prop('checked', true);
                $('#fullMobilityEyeballs-descr input').attr('disabled', true);
                $('#fullMobilityEyeballs-descr').addClass('disabled-box');
            } else {
                $('#mobilityEyeballs-limitationMuscles').val(userFormData.MobilityEyeballsLimitationMuscles);
                $('#mobilityEyeballs-nerveParesis').val(userFormData.MobilityEyeballsNerveParesis);
            }

            //Closest point of convergence
            $('#btk').val(userFormData.Btk);

            //PD monocular table - output closed 11.2022 - because the table is closed
        /*    $('#pdMonocular-OD-distance').val(userFormData.PdMonocular.OD.distance);
            $('#pdMonocular-OD-near').val(userFormData.PdMonocular.OD.near);
            $('#pdMonocular-OS-distance').val(userFormData.PdMonocular.OS.distance);
            $('#pdMonocular-OS-near').val(userFormData.PdMonocular.OS.near);*/


            //VISUS without correction table
            $('input[list="visusWithoutCorrection-distance-OD"]').val(userFormData.VisusWithoutCorrection.distance.OD);
            $('input[list="visusWithoutCorrection-distance-OS"]').val(userFormData.VisusWithoutCorrection.distance.OS);
            $('input[list="visusWithoutCorrection-distance-OU"]').val(userFormData.VisusWithoutCorrection.distance.OU);
            $('input[list="visusWithoutCorrection-near-OD"]').val(userFormData.VisusWithoutCorrection.near.OD);
            $('input[list="visusWithoutCorrection-near-OS"]').val(userFormData.VisusWithoutCorrection.near.OS);
            $('input[list="visusWithoutCorrection-near-OU"]').val(userFormData.VisusWithoutCorrection.near.OU);


            //With the correction of the "best" sphere table
            $('input[list="correctionBestSphereOD-sph"]').val(userFormData.CorrectionBestSphere.OD.sph.value);
            $('input[list="correctionBestSphereOD-sph-main"]').val(userFormData.CorrectionBestSphere.OD.sph.main);
            $('input[list="correctionBestSphereOD-sph-main-equally"]').val(userFormData.CorrectionBestSphere.OD.sph.equally);
            $('input[list="correctionBestSphereOD-cyl"]').val(userFormData.CorrectionBestSphere.OD.cyl);
            $('input[list="correctionBestSphereOD-ax"]').val(userFormData.CorrectionBestSphere.OD.ax);
            $('input[list="correctionBestSphereOD-equally"]').val(userFormData.CorrectionBestSphere.OD.equally);
            $('input[list="correctionBestSphereOS-sph"]').val(userFormData.CorrectionBestSphere.OS.sph.value);
            $('input[list="correctionBestSphereOS-sph-main"]').val(userFormData.CorrectionBestSphere.OS.sph.main);
            $('input[list="correctionBestSphereOS-sph-main-equally"]').val(userFormData.CorrectionBestSphere.OS.sph.equally);
            $('input[list="correctionBestSphereOS-cyl"]').val(userFormData.CorrectionBestSphere.OS.cyl);
            $('input[list="correctionBestSphereOS-ax"]').val(userFormData.CorrectionBestSphere.OS.ax);
            $('input[list="correctionBestSphereOS-equally"]').val(userFormData.CorrectionBestSphere.OS.equally);
            $('input[id="correctionBestSphere-OU"]').val(userFormData.CorrectionBestSphere.OU);

            //Refine the scope of the table
            $('input[id="clarifying-OD"]').val(userFormData.Clarifying.OD);
            $('input[id="clarifying-OS"]').val(userFormData.Clarifying.OS);

            //Refine cyl table
            $('input[list="specifyingCyl1-sph"]').val(userFormData.SpecifyingCyl.OD.sph);
            $('input[list="specifyingCyl1-cyl"]').val(userFormData.SpecifyingCyl.OD.cyl);
            $('input[list="specifyingCyl1-ax"]').val(userFormData.SpecifyingCyl.OD.ax);
            $('input[id="specifyingCyl1-equally"]').val(userFormData.SpecifyingCyl.OD.equally);
            $('input[list="specifyingCyl2-sph"]').val(userFormData.SpecifyingCyl.OS.sph);
            $('input[list="specifyingCyl2-cyl"]').val(userFormData.SpecifyingCyl.OS.cyl);
            $('input[list="specifyingCyl2-ax"]').val(userFormData.SpecifyingCyl.OS.ax);
            $('input[id="specifyingCyl2-equally"]').val(userFormData.SpecifyingCyl.OS.equally);

            //Leading eye fetch radio
            let leadingEye = userFormData.LeadingEye;
            $('#leadingEye-box input[value="'+leadingEye+'"]').prop('checked', true);

            //We check the absence of gross binocular disturbances radio sample
            let binocularDisorders = userFormData.BinocularDisorders;
            $('input[name="binocularDisorders"][value="'+binocularDisorders+'"]').prop('checked', true);

            //measure PTA table
            $('input[list="pta-OD-Sph"]').val(userFormData.Pta.OD.sph);
            $('input[list="pta-OS-Sph"]').val(userFormData.Pta.OS.sph);

            //Accommodation-refractive balance
            $('input[list="accommodationRefractiveBalance-OD-sph"]').val(userFormData.AccommodationRefractiveBalance.OD.sph);
            $('input[list="accommodationRefractiveBalance-OS-sph"]').val(userFormData.AccommodationRefractiveBalance.OS.sph);

            //Distance visual acuity table
            $('input[id="visualDistance-OU"]').val(userFormData.VisualDistance.OU);
            $('input[id="visualDistance-OS"]').val(userFormData.VisualDistance.OS);
            $('input[id="visualDistance-OD"]').val(userFormData.VisualDistance.OD);

            //Character view  - sampling radio
            let natureVision = userFormData.NatureVision;
            $('input[name="natureVision"][value="'+natureVision+'"]').prop('checked', true);


            //Schober test - radio sample
            let schoberTest = userFormData.SchoberTest;
            $('#schoberTest-box input[value="'+schoberTest+'"]').prop('checked', true);

            //Crosses
            $('input[id="cross-withoutFixation"]').val(userFormData.CrossWithoutFixsation);
            $('input[id="cross-fixation"]').val(userFormData.CrossFixsaton);

            //Aniseikonia
            $('input[id="aniseikonia-staples"]').val(userFormData.AniseikoniaStaples);

            //Stereotests - sampling radio
            let stereotestsItem = userFormData.StereoTests.yn;
            $('#stereotests-btn input[value="'+stereotestsItem+'"]').prop('checked', true).addClass('checked');

            //Prism table
            $('input[list="prismsOD-sph"]').val(userFormData.Prisms.OD.sph);
            $('input[list="prismsOD-cyl"]').val(userFormData.Prisms.OD.cyl);
            $('input[list="prismsOD-ax"]').val(userFormData.Prisms.OD.ax);
            $('input[list="prismsOD-pr1"]').val(userFormData.Prisms.OD.pr1);
            $('input[list="prismsOD-bas"]').val(userFormData.Prisms.OD.bas);
            $('input[list="prismsOD-pr2"]').val(userFormData.Prisms.OD.pr2);
            $('input[list="prismsOD-bas2"]').val(userFormData.Prisms.OD.bas2);
            $('input[list="prismsOD-VIS"]').val(userFormData.Prisms.OD.VIS);
            $('input[id="prismsOD-PD"]').val(userFormData.Prisms.OD.PD);
            $('input[list="prismsOS-sph"]').val(userFormData.Prisms.OS.sph);
            $('input[list="prismsOS-cyl"]').val(userFormData.Prisms.OS.cyl);
            $('input[list="prismsOS-ax"]').val(userFormData.Prisms.OS.ax);
            $('input[list="prismsOS-pr1"]').val(userFormData.Prisms.OS.pr1);
            $('input[list="prismsOS-bas"]').val(userFormData.Prisms.OS.bas);
            $('input[list="prismsOS-pr2"]').val(userFormData.Prisms.OS.pr2);
            $('input[list="prismsOS-bas2"]').val(userFormData.Prisms.OS.bas2);
            $('input[list="prismsOS-VIS"]').val(userFormData.Prisms.OS.VIS);
            $('input[id="prismsOS-PD"]').val(userFormData.Prisms.OS.PD);
            $('input[list="prismsOSOD-OU"]').val(userFormData.Prisms.OSOD.OU);
            $('textarea[id="prismReversal"]').val(userFormData.PrismReversal);

            //Accommodation study table
            $('input[list="accommodationResearch-vis"]').val(userFormData.AccommodationResearch.vis);
            $('input[id="accommodationResearch-volumePPOD"]').val(userFormData.AccommodationResearch.volume.PP.OD);
            $('input[id="accommodationResearch-volumePPOS"]').val(userFormData.AccommodationResearch.volume.PP.OS);
            $('input[id="accommodationResearch-volumeОААOS"]').val(userFormData.AccommodationResearch.volume.oaa.OS);
            $('input[id="accommodationResearch-volumeОААOD"]').val(userFormData.AccommodationResearch.volume.oaa.OD);
            $('input[id="accommodationResearch-comfortPPOD"]').val(userFormData.AccommodationResearch.comfort.OD);
            $('input[id="accommodationResearch-comfortPPOS"]').val(userFormData.AccommodationResearch.comfort.OS);
            $('input[id="accommodationResearch-zoa"]').val(userFormData.AccommodationResearch.zoa);
            $('input[list="flexibilityAccommodation-OD"]').val(userFormData.AccommodationResearch.flexibility.OD);
            $('input[list="flexibilityAccommodation-OS"]').val(userFormData.AccommodationResearch.flexibility.OS);
           $('input[list="flexibilityAccommodation-OU"]').val(userFormData.AccommodationResearch.flexibility.OU);
           $('input[list="addition-OU"]').val(userFormData.AccommodationResearch.addition);
           $('input[id="refinementAddition-pushUpTest"]').val(userFormData.AccommodationResearch.refinement.pushUpTest);
           $('input[id="refinementAddition-add"]').val(userFormData.AccommodationResearch.refinement.add);
           $('input[id="refinementAddition-GridTest"]').val(userFormData.AccommodationResearch.refinement.gridTest);
           $('input[id="balanceNear-OD"]').val(userFormData.AccommodationResearch.balanceNear.OD);
           $('input[id="balanceNear-OS"]').val(userFormData.AccommodationResearch.balanceNear.OS);
           $('input[id="accommodationResearch-btk"]').val(userFormData.AccommodationResearch.btk);
           $('input[id="measurePhoria-howell"]').val(userFormData.AccommodationResearch.measurePhoria.howell);
           $('input[id="measurePhoria-torrington"]').val(userFormData.AccommodationResearch.measurePhoria.torrington);
           $('input[id="measurePhoria-POSB"]').val(userFormData.AccommodationResearch.measurePhoria.POSB);
           $('input[id="accommodationResearch-ak"]').val(userFormData.AccommodationResearch.pm10.ak);
           $('input[id="accommodationResearch-prismReversal"]').val(userFormData.AccommodationResearch.pm10.prismReversal);
           $('input[id="accommodationResearch-finalAddition"]').val(userFormData.AccommodationResearch.pm11.finalAddition);
           $('input[id="visual-acuity-near"]').val(userFormData.AccommodationResearch.pm11.visualAcuityNear);
           $('input[id="accommodationResearch-OU"]').val(userFormData.AccommodationResearch.pm11.OU);

            // prescription for glasses - default

            //cut the first element from the array, put it in the form.
            let receiptGlass0 = userFormData.ReceiptGlass.shift();


            //Prescription for VISUS glasses before and after
            $('input[id="receiptGlassOD-visus-before"]').val(receiptGlass0.OD.visus.before);
            $('input[id="receiptGlassOS-visus-before"]').val(receiptGlass0.OS.visus.before);
            $('input[id="receiptGlassOD-visus-after"]').val(receiptGlass0.OD.visus.after);
            $('input[id="receiptGlassOS-visus-after"]').val(receiptGlass0.OS.visus.after);

            //Prescription glasses table
            $('input[list="receiptGlassOD-sph"]').val(receiptGlass0.OD.sph);
            $('input[list="receiptGlassOD-cyl"]').val(receiptGlass0.OD.cyl);
            $('input[list="receiptGlassOD-ax"]').val(receiptGlass0.OD.ax);
            $('input[list="receiptGlassOD-add"]').val(receiptGlass0.OD.add);
            $('input[list="receiptGlassOD-pr1"]').val(receiptGlass0.OD.pr1);
            $('input[list="receiptGlassOD-bas1"]').val(receiptGlass0.OD.bas1);
            $('input[list="receiptGlassOD-pr2"]').val(receiptGlass0.OD.pr2);
            $('input[list="receiptGlassOD-bas2"]').val(receiptGlass0.OD.bas2);
            $('input[list="receiptGlassOS-sph"]').val(receiptGlass0.OS.sph);
            $('input[list="receiptGlassOS-cyl"]').val(receiptGlass0.OS.cyl);
            $('input[list="receiptGlassOS-ax"]').val(receiptGlass0.OS.ax);
            $('input[list="receiptGlassOS-add"]').val(receiptGlass0.OS.add);
            $('input[list="receiptGlassOS-pr1"]').val(receiptGlass0.OS.pr1);
            $('input[list="receiptGlassOS-bas1"]').val(receiptGlass0.OS.bas1);
            $('input[list="receiptGlassOS-pr2"]').val(receiptGlass0.OS.pr2);
            $('input[list="receiptGlassOS-bas2"]').val(receiptGlass0.OS.bas2);

            //Рprescription for glasses base - selection radio:
            // 1. check if there are zeros in four fields, if there is at least one, then the selection is disabled.
            // 2. check the desired value for the footing
            if (receiptGlass0.OD.pr1 !== '0' && receiptGlass0.OD.pr2 !== '0' && receiptGlass0.OS.pr1 !== '0' && receiptGlass0.OS.pr2 !== '0') {
                $('#footing-box0').removeClass('disabled-box');
                $('#footing-box0 input').attr('disabled', false).attr('required', true);
            } else {
                $('#footing-box0').addClass('disabled-box');
                $('#footing-box0 input').attr('disabled', true).attr('required', false);
            }
            let footing = receiptGlass0.footing;
            if(footing !== null){
                $('#footing-box0 input[value="'+footing+'"]').prop('checked', true);
            }


            //Prescription for glasses RC distance + near
            $('input[id="receiptGlassOD-rc-distance"]').val(receiptGlass0.OD.rc.distance);
            $('input[id="receiptGlassOS-rc-distance"]').val(receiptGlass0.OS.rc.distance);
            $('input[id="receiptGlassOD-rc-near"]').val(receiptGlass0.OD.rc.near);
            $('input[id="receiptGlassOS-rc-near"]').val(receiptGlass0.OD.rc.near);

            $('textarea[id="recommendedCoatedLens"]').val(receiptGlass0.recommendedCoatedLens);

            //Glasses prescription glasses lenses list chexbox
            let GlassLenses = receiptGlass0.lenses;
            if(GlassLenses !== undefined){
                GlassLenses.forEach((item)=>{
                    $('.receiptGlassLensValidation__box input[value="' + item +'"]').prop('checked', true)
                });
            }

            //Glasses prescription recommendations, notes, diagnosis
            $('textarea[id="receiptGlass-recommendations"]').text(receiptGlass0.recommendations);
            $('textarea[id="receiptGlass-notes"]').text(receiptGlass0.notes);
            $('textarea[id="receiptGlass-diagnosis"]').text(receiptGlass0.diagnosis);


            //Glasses lenses type list chexbox
            let GlassLensesType = receiptGlass0.lensesType;
            if(GlassLensesType !== undefined){
                GlassLensesType.forEach((item)=>{
                    $('.receiptGlassTypeLensValidation__box input[value="' + item +'"]').prop('checked', true)
                });
            }


            //glasses prescription - generation
            //already cut out the first element - it is for default. and this remainder to generate
            this.receiptGlassCounter = userFormData.ReceiptGlass.length;
            let self =  this;
            userFormData.ReceiptGlass.forEach(function(item, index) {
                index++;
                $('#receiptGlassListGenerate').append('' +
                    '<div class="col-sm-12 mt-3 newReceiptGlassBox" id="newReceiptGlassBox'+ index +'">' +
                        '<button type="button" class="btn btn-danger newReceiptGlassBtn" data-action="click->form-creation#deleteNewReceiptGlass" data-form-creation-del-param="newReceiptGlassBox'+ index +'">Удалить</button>' +
                    '<strong>Рецепт на очки #'+ ((index)+1) +' </strong>' +
                    ' \n' +
                    '                        <div class="col-sm-6 mt-3">\n' +
                    '                            <table class="table table-bordered vision-table">\n' +
                    '                                <thead>\n' +
                    '                                    <tr>\n' +
                    '                                        <th></th>\n' +
                    '                                        <th>OD</th>\n' +
                    '                                        <th>OS</th>\n' +
                    '                                    </tr>\n' +
                    '                                </thead>\n' +
                    '                                <tbody>\n' +
                    '                                    <tr>\n' +
                    '                                        <td><div class="vision-table-title">Visus <br><span class="form-text">без коррекции</span></div></td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control" id="receiptGlass'+ index +'OD-visus-before" type="number" value="'+item.OD.visus.before+'" step="0.01" min="-20" max="20" name="receiptGlass['+ index +'][OD][visus][before]"  autocomplete="off" />\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control" id="receiptGlass'+ index +'OS-visus-before" type="number" value="'+item.OS.visus.before+'" step="0.01" min="-20" max="20" name="receiptGlass['+ index +'][OS][visus][before]"  autocomplete="off" />\n' +
                    '                                        </td>\n' +
                    '                                    </tr>\n' +
                    '                                </tbody>\n' +
                    '                            </table>\n' +
                    '                        </div>\n' +
                    '\n' +
                    '                       \n' +
                    '                        <div class="col-sm-12 mt-3">\n' +
                    '                            <table class="table table-bordered vision-table">\n' +
                    '                                <thead>\n' +
                    '                                    <tr>\n' +
                    '                                        <th class=""></th>\n' +
                    '                                        <th class="vision-table-bg">sph</th>\n' +
                    '                                        <th class="vision-table-bg">cyl</th>\n' +
                    '                                        <th class="vision-table-bg">ax</th>\n' +
                    '                                        <th class="vision-table-bg">Add</th>\n' +
                    '                                        <th class="vision-table-bg">pr1</th>\n' +
                    '                                        <th class="vision-table-bg">bas</th>\n' +
                    '                                        <th class="vision-table-bg">pr2</th>\n' +
                    '                                        <th class="vision-table-bg">bas</th>\n' +
                    '                                    </tr>\n' +
                    '                                </thead>\n' +
                    '                                <tbody>\n' +
                    '                                    <tr>\n' +
                    '                                        <td><div class="vision-table-title">OD</div></td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control sphList" list="receiptGlass'+ index +'OD-sph" type="number" value="'+item.OD.sph+'" step="0.01" min="-20" max="20" name="receiptGlass['+ index +'][OD][sph]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OD-sph"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control cylList" list="receiptGlass'+ index +'OD-cyl" type="number" value="'+item.OD.cyl+'" step="0.01"  min="-12" max="12" name="receiptGlass['+ index +'][OD][cyl]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OD-cyl"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control axList" list="receiptGlass'+ index +'OD-ax" type="number" value="'+item.OD.ax+'" step="0.01"  min="0" max="180" name="receiptGlass['+ index +'][OD][ax]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OD-ax"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control addList" list="receiptGlass'+ index +'OD-add" type="number" value="'+item.OD.add+'" step="0.01"  min="0" max="5.0" name="receiptGlass['+ index +'][OD][add]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OD-add"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control prList receiptGlassPr'+ index +'" list="receiptGlass'+ index +'OD-pr1" type="number" value="'+item.OD.pr1+'" step="0.01"  min="0" max="20" name="receiptGlass['+ index +'][OD][pr1]" autocomplete="off" required=""  data-action="change->form-creation#receiptGlassPr" data-form-creation-index-param="'+ index +'" data-form-creation-id-param="'+ index +'"/>\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OD-pr1"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control basList" list="receiptGlass'+ index +'OD-bas1" type="number" value="'+item.OD.bas1+'" step="0.01"  min="0" max="270" name="receiptGlass['+ index +'][OD][bas1]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OD-bas1"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control prList receiptGlassPr'+ index +'" list="receiptGlass'+ index +'OD-pr2" type="number" value="'+item.OD.pr2+'" step="0.01"  min="0" max="20" name="receiptGlass['+ index +'][OD][pr2]"  autocomplete="off" required="" data-action="change->form-creation#receiptGlassPr" data-form-creation-index-param="'+ index +'" data-form-creation-id-param="'+ index +'" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OD-pr2"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control basList" list="receiptGlass'+ index +'OD-bas2" type="number" value="'+item.OD.bas2+'" step="0.01"  min="0" max="270" name="receiptGlass['+ index +'][OD][bas2]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OD-bas2"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                    </tr>\n' +
                    '                                    <tr>\n' +
                    '                                        <td><div class="vision-table-title">OS</div></td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control sphList" list="receiptGlass'+ index +'OS-sph" type="number" value="'+item.OS.sph+'" step="0.01" min="-20" max="20" name="receiptGlass['+ index +'][OS][sph]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OS-sph"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control cylList" list="receiptGlass'+ index +'OS-cyl" type="number" value="'+item.OS.cyl+'" step="0.01"  min="-12" max="12" name="receiptGlass['+ index +'][OS][cyl]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OS-cyl"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control axList" list="receiptGlass'+ index +'OS-ax" type="number" value="'+item.OS.ax+'" step="0.01"  min="0" max="180" name="receiptGlass['+ index +'][OS][ax]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OS-ax"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control addList" list="receiptGlass'+ index +'OS-add" type="number" value="'+item.OS.add+'" step="0.01"  min="0" max="5.0" name="receiptGlass['+ index +'][OS][add]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OS-add"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control prList receiptGlassPr'+ index +'" list="receiptGlass'+ index +'OS-pr1" type="number" value="'+item.OS.pr1+'" step="0.01"  min="0" max="20" name="receiptGlass['+ index +'][OS][pr1]"  autocomplete="off" required="" data-action="change->form-creation#receiptGlassPr" data-form-creation-index-param="'+ index +'" data-form-creation-id-param="'+ index +'" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OS-pr1"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control basList" list="receiptGlass'+ index +'OS-bas1" type="number" value="'+item.OS.bas1+'" step="0.01"  min="0" max="270" name="receiptGlass['+ index +'][OS][bas1]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OS-bas1"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control prList receiptGlassPr'+ index +'" list="receiptGlass'+ index +'OS-pr2" type="number" value="'+item.OS.pr2+'" step="0.01"  min="0" max="20" name="receiptGlass['+ index +'][OS][pr2]"  autocomplete="off" required="" data-action="change->form-creation#receiptGlassPr" data-form-creation-index-param="'+ index +'" data-form-creation-id-param="'+ index +'" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OS-pr2"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control basList" list="receiptGlass'+ index +'OS-bas2" type="number" value="'+item.OS.bas2+'" step="0.01"  min="0" max="270" name="receiptGlass['+ index +'][OS][bas2]"  autocomplete="off" required="" />\n' +
                    '                                            <datalist id="receiptGlass'+ index +'OS-bas2"></datalist>\n' +
                    '                                        </td>\n' +
                    '                                    </tr>\n' +
                    '                                </tbody>\n' +
                    '                            </table>\n' +
                    '                        </div>\n' +
                    '\n' +
                    '                      \n' +
                    '                        <div class="col-sm-6 mt-3">\n' +
                    '                            <table class="table table-bordered vision-table">\n' +
                    '                                <thead>\n' +
                    '                                    <tr>\n' +
                    '                                        <th></th>\n' +
                    '                                        <th>OD</th>\n' +
                    '                                        <th>OS</th>\n' +
                    '                                    </tr>\n' +
                    '                                </thead>\n' +
                    '                                <tbody>\n' +
                    '                                    <tr>\n' +
                    '                                        <td><div class="vision-table-title">Visus <br><span class="form-text">после коррекции</span></div></td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control" id="receiptGlass'+ index +'OD-visus-after" type="number" value="'+item.OD.visus.after+'" step="0.01" min="-20" max="20" name="receiptGlass['+ index +'][OD][visus][after]"  autocomplete="off" />\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control" id="receiptGlass'+ index +'OD-visus-after" type="number" value="'+item.OS.visus.after+'" step="0.01" min="-20" max="20" name="receiptGlass['+ index +'][OS][visus][after]"  autocomplete="off" />\n' +
                    '                                        </td>\n' +
                    '                                    </tr>\n' +
                    '                                </tbody>\n' +
                    '                            </table>\n' +
                    '                        </div>\n' +
                    ' \n' +
                    '                        <div class="col-sm-12 mt-3 disabled-box"  id="footing-box'+ index +'">\n' +
                    '                            <div class="col-sm-6">\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="radio" value="bi" class="form-check-input" name="receiptGlass['+ index +'][footing]" id="footing'+ index +'-bi" disabled >\n' +
                    '                                    <label class="form-check-label" for="footing'+ index +'-bi">BI (основание внутрь)</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="radio" value="bo" class="form-check-input" name="receiptGlass['+ index +'][footing]" id="footing'+ index +'-bo" disabled >\n' +
                    '                                    <label class="form-check-label" for="footing'+ index +'-bo">BO (основание к виску)</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="radio" value="bu" class="form-check-input" name="receiptGlass['+ index +'][footing]" id="footing'+ index +'-bu" disabled >\n' +
                    '                                    <label class="form-check-label" for="footing'+ index +'-bu">BU (основание вверх)</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="radio" value="bd" class="form-check-input" name="receiptGlass['+ index +'][footing]" id="footing'+ index +'-bd" disabled >\n' +
                    '                                    <label class="form-check-label" for="footing'+ index +'-bd">BD (основание вниз)</label>\n' +
                    '                                </div>\n' +
                    '                            </div>\n' +
                    '                        </div>\n' +
                    '\n' +
                    '                    \n' +
                    '                        <div class="col-sm-6 mt-3">\n' +
                    '                            <table class="table table-bordered vision-table">\n' +
                    '                                <thead>\n' +
                    '                                    <tr>\n' +
                    '                                        <th></th>\n' +
                    '                                        <th>OD</th>\n' +
                    '                                        <th>OS</th>\n' +
                    '                                    </tr>\n' +
                    '                                </thead>\n' +
                    '                                <tbody>\n' +
                    '                                    <tr>\n' +
                    '                                        <td><div class="vision-table-title">РЦ даль</div></td>\n' +
                    '\n' +


                    '                                        <td>\n' +
                    '                                            <input class="form-control" id="receiptGlass'+ index +'OD-rc-distance" type="number" value="'+item.OD.rc.distance+'" step="0.01" name="receiptGlass['+ index +'][OD][rc][distance]" autocomplete="off" />\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control" id="receiptGlass'+ index +'OS-rc-distance" type="number" value="'+item.OS.rc.distance+'" step="0.01" name="receiptGlass['+ index +'][OS][rc][distance]" autocomplete="off" />\n' +
                    '                                        </td>\n' +
                    '                                    </tr>\n' +
                    '                                    <tr>\n' +
                    '                                        <td><div class="vision-table-title">РЦ близь</div></td>\n' +
                    '\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control" id="receiptGlass'+ index +'OD-rc-near" type="number" value="'+item.OD.rc.near+'" step="0.01" name="receiptGlass['+ index +'][OD][rc][near]" autocomplete="off" />\n' +
                    '                                        </td>\n' +
                    '                                        <td>\n' +
                    '                                            <input class="form-control" id="receiptGlass'+ index +'OS-rc-near" type="number" value="'+item.OS.rc.near+'" step="0.01" name="receiptGlass['+ index +'][OS][rc][near]" autocomplete="off" />\n' +
                    '                                        </td>\n' +
                    '                                    </tr>\n' +
                    '                                </tbody>\n' +
                    '                            </table>\n' +
                    '                        </div>\n' +
                    '\n' +
                    '                      \n' +
                    '                        <div class="row col-sm-12 mt-3 receiptGlassLensValidation__box'+ index +'">\n' +
                    '                            <div class="col-sm-6 ">\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="checkbox" value="distanse" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ index +'][lenses][]" id="lenses-distanse'+ index +'"  >\n' +
                    '                                    <label class="form-check-label" for="lenses-distanse'+ index +'">Даль</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="checkbox" value="reader" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ index +'][lenses][]" id="lenses-reader'+ index +'"  >\n' +
                    '                                    <label class="form-check-label" for="lenses-reader'+ index +'">Близь</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="checkbox" value="constance" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ index +'][lenses][]" id="lenses-constance'+ index +'"  >\n' +
                    '                                    <label class="form-check-label" for="lenses-constance'+ index +'">Постоянное ношение</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="checkbox" value="provision" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ index +'][lenses][]" id="lenses-provision'+ index +'"  >\n' +
                    '                                    <label class="form-check-label" for="lenses-provision'+ index +'">Курс Provision</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                            </div>\n' +
                    '                            <div class="col-sm-6">\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="checkbox" value="single" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ index +'][lenses][]" id="lenses-single'+ index +'" >\n' +
                    '                                    <label class="form-check-label" for="lenses-single'+ index +'">Однофокальные</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="checkbox" value="progressive" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ index +'][lenses][]" id="lenses-progressive'+ index +'" >\n' +
                    '                                    <label class="form-check-label" for="lenses-progressive'+ index +'">Прогрессивные</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="checkbox" value="bifocal" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ index +'][lenses][]" id="lenses-bifocal'+ index +'" >\n' +
                    '                                    <label class="form-check-label" for="lenses-bifocal'+ index +'">Бифокальные</label>\n' +
                    '                                </div>\n' +
                    '\n' +
                    '                                <div class="form-check">\n' +
                    '                                    <input type="checkbox" value="office" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ index +'][lenses][]" id="lenses-office'+ index +'" >\n' +
                    '                                    <label class="form-check-label" for="lenses-office'+ index +'">Офисные</label>\n' +
                    '                                </div>\n' +
                    '                            </div>\n' +
                    '                        </div>' +
                    '                        <div class="col-sm-12 mt-4">\n' +
                    '                            <label class="form-label" for="recommendedCoatedLens'+ index +'">Рекомендуемая оптическая линза с покрытием</label>\n' +
                    '                            <textarea type="text" class="form-control" name="receiptGlass['+ index +'][recommendedCoatedLens]" id="recommendedCoatedLens'+ index +'">'+item.recommendedCoatedLens+'</textarea>\n' +
                    '                        </div>' +
                    '' +
                    '</div>');

                self.receiptGlassPr({
                    params: {
                        index: index
                    }
                });
                let footing = item.footing;
                if(footing !== null){
                    $('#footing-box'+index+' input[value="'+footing+'"]').prop('checked', true);
                }

                let GlassLensesGen = item.lenses;
                if(GlassLensesGen !== undefined){
                    GlassLensesGen.forEach((item)=>{
                        $('.receiptGlassLensValidation__box'+ index +' input[value="' + item +'"]').prop('checked', true)
                    });
                }

            });



            //Prescription for contact lenses table + fields
            console.debug(userFormData.ReceiptLens);
            if (userFormData.ReceiptLens !== null) {
                console.debug('ЕСТЬ МКЛ');

                $('#contact-lens-delete').prop('checked', false);
                $('#contact-lens-delete-box').removeClass('disabled-box');
                $('#contact-lens-delete-box input, #contact-lens-delete-box textarea').attr('disabled', false);

                $('input[list="receiptLensOD-sph"]').val(userFormData.ReceiptLens.OD.sph);
                $('input[list="receiptLensOD-cyl"]').val(userFormData.ReceiptLens.OD.cyl);
                $('input[list="receiptLensOD-ax"]').val(userFormData.ReceiptLens.OD.ax);
                $('input[list="receiptLensOD-add"]').val(userFormData.ReceiptLens.OD.add);
                $('input[id="receiptLensOD-bc"]').val(userFormData.ReceiptLens.OD.bc);
                $('input[id="receiptLensOD-dia"]').val(userFormData.ReceiptLens.OD.dia);
                $('input[list="receiptLensOS-sph"]').val(userFormData.ReceiptLens.OS.sph);
                $('input[list="receiptLensOS-cyl"]').val(userFormData.ReceiptLens.OS.cyl);
                $('input[list="receiptLensOS-ax"]').val(userFormData.ReceiptLens.OS.ax);
                $('input[list="receiptLensOS-add"]').val(userFormData.ReceiptLens.OS.add);
                $('input[id="receiptLensOS-bc"]').val(userFormData.ReceiptLens.OS.bc);
                $('input[id="receiptLensOS-dia"]').val(userFormData.ReceiptLens.OS.dia);

                //lens type selection checkbox + box
                console.debug(userFormData.ReceiptLens);
                let receiptLensType = userFormData.ReceiptLens.type;
                if (receiptLensType !== undefined) {
                    receiptLensType.forEach((item)=>{
                        $('#receiptLens-type-box input[value="' + item +'"]').prop('checked', true)
                    });
                }

                if(userFormData.ReceiptLens.typeOther !== null){
                    $('input[id="type-other-description"]').val(userFormData.ReceiptLens.typeOther);
                }
                if ($('#type-other').prop("checked") === true) {
                    $('#receiptLens-other-box').removeClass('disabled-box');
                    $('#type-other-description').attr('disabled', false).attr('required', true);
                }

                $('input[id="receiptLens-name"]').val(userFormData.ReceiptLens.name);
                $('input[id="receiptLens-mode"]').val(userFormData.ReceiptLens.mode);
                $('input[id="receiptLens-wearing"]').val(userFormData.ReceiptLens.wearing);
                $('textarea[id="conditionCornea"]').val(userFormData.ReceiptLens.conditionCornea);
                $('textarea[id="conditionConjunctival"]').val(userFormData.ReceiptLens.conditionConjunctival);
                //$('textarea[id="recommendedCoatedLens"]').val(userFormData.ReceiptLens.recommendedCoatedLens);

                //Landing MKL - sampling radio
                let fitSCL = userFormData.ReceiptLens.fit;
                $('#fitSCL-box input[value="'+fitSCL+'"]').prop('checked', true);

            }


            //check text input - default values
            let inputText = $('input.form-control[type="text"]');
            let textareaText = $('textarea.form-control');
            let listDefault = $.merge(inputText,textareaText);
            for (let index = 0; index < listDefault.length; ++index) {
                 let item = $(listDefault[index]);
                if(item.val() === 'нет данных'){
                    item.parent().addClass('noDataBox');
                }
                item.change(function (){
                    if(item.val() !== 'нет данных'){
                        item.parent().removeClass('noDataBox');
                    } else {
                        item.parent().addClass('noDataBox');
                    }
                })
            }

        } catch (error){
            console.debug(error)
        }

    }

    //edit  the patient's medical questionnaire
    editForm(){
        this.checkToken();
        let formUserId = $('#form-creation').attr('data-form');
        //edit data
        $('#doctorName').after('<input type="hidden" name="profileId" value="' + formUserId + '">');
        $('#clientPhone').attr('readonly', true);
        $('.nextAppointmentDateNote').remove();
    }

    //copy  the patient's medical questionnaire
    copyForm(){
        this.checkToken();
        $('#clientPhone').attr('readonly', true);
        $('#clientName').attr('readonly', true);
        $('#clientSurname').attr('readonly', true);
        $('#clientDateBirth').attr('readonly', true);
        $('#clientAge').attr('readonly', true);
        $('#clientFirstRequest').attr('readonly', true);
        $('.nextAppointmentDateNote').remove();
    }

    addFromSchedule(){
        this.checkToken();
        let patientName = $('#form-creation').attr('data-name');
        let patientSurname = $('#form-creation').attr('data-surname');
        let patientPnone = $('#form-creation').attr('data-pnone');
        let patientDatebirth = $('#form-creation').attr('data-datebirth');

        $('#clientName').val(patientName);
        $('#clientSurname').val(patientSurname);
        $('#clientDateBirth').val(patientDatebirth);
        $('#clientPhone').val(patientPnone);

        let dateNow = new Date();
        dateNow = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
        let clientBirthday = patientDatebirth;
        clientBirthday = clientBirthday.split(".");
        clientBirthday = new Date(clientBirthday[2], clientBirthday[1] - 1, clientBirthday[0]);
        clientBirthday = new Date(clientBirthday.getFullYear(), clientBirthday.getMonth(), clientBirthday.getDate());
        let clientBirthdayNow = new Date(dateNow.getFullYear(), clientBirthday.getMonth(), clientBirthday.getDate());              let age;
        age = dateNow.getFullYear() - clientBirthday.getFullYear();
        if (dateNow < clientBirthdayNow) {
            age = age-1;
        }
        $('#clientAge').val(age);

    }

    //clean patient's medical questionnaire
    formCancel(){
        this.checkToken();
        $('#optic-form').smartWizard("reset");
        $('#form-step-1').trigger('reset');
        $('#form-step-2').trigger('reset');
        $('#form-step-3').trigger('reset');
        $('#form-step-4').trigger('reset');
        $('#form-step-5').trigger('reset');
        $('#form-step-6').trigger('reset');
    }

    //save patient's medical questionnaire
    async formConfirm(event) {
        this.checkToken();
        $('#btnFinishPrint').attr('disabled', 'disabled');
        $('#btnFinish').attr('disabled', 'disabled');
        $('.form-buttons__confirm').html('<div class="alert alert-warning"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#664d03" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="loader-orderBtn"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg> Пожалуйста, подождите, информация сохраняется</div>');

        let formEnd = document.getElementById('form-step-6');
        let opticForm =  $('#optic-form');
        if (formEnd.checkValidity()) {

            //getting data from 6 forms - 6 steps
            let formStep1 = $($("#form-step-1")[0]).serializeObject();
            formStep1.clientPhone = formStep1.clientPhone.replace(/[^0-9]/g, '');
            let formStep2 = $($("#form-step-2")[0]).serializeObject();
            let formStep3 = $($("#form-step-3")[0]).serializeObject();
            let formStep4 = $($("#form-step-4")[0]).serializeObject();
            let formStep5 = $($("#form-step-5")[0]).serializeObject();
            let formStep6 = $($("#form-step-6")[0]).serializeObject();

            //merge all our arrays into one, turn the new array into json
            let json = $.extend({},formStep1,formStep2,formStep3,formStep4,formStep5,formStep6);


            api.createAnketa(json).then((result)=> {

                if(event.params.save === 'save'){
                    this.checkToken();
                    $('#titlePageBox').remove();
                    $('#form-creation').remove();
                    $('.xdsoft_datetimepicker').remove();
                    $('#headerContentTitle').html('Список пациентов');
                    $('#template__header').after('' +
                        '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
                         '<div class="ms-auto" data-controller="database">' +
                        '<button type="button" class="btn btn-light btnIcon" data-action="click->database#showMySchedule"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Расписание</button>' +
                        '<button type="button" class="btn btn-light" data-action="click->database#addNewForm">Заполнить новую форму</button>' +
                        '</div>' +
                        '</div>' +
                        '<div class="container-fluid database__main" id="database" data-controller="database"></div>');
                } else {
                    this.checkToken();
                    $('#titlePageBox').remove();
                    $('#form-creation').remove();
                    $('#template__header').after('' +
                        '<div class="d-none d-sm-flex align-items-center mb-3 title-page__box d-print-none" id="titlePageBox">' +
                        '<h1 class="title-page">Консультативный лист #'+result.profileId+' от <span id="createdAtDate"></span></h1>' +
                        '<div class="ms-auto" data-controller="database">' +
                        '<button type="button" class="btn btn-light" data-action="click->database#goToDatabase">База данных клиентов</button>' +
                        '</div>' +
                        '</div>' +
                        '<div class="container-fluid form__main" id="userdoc" data-controller="userdoc" data-form="'+ result.profileId +'" data-form-print="print"></div>');
                    $('body,html').animate({
                        scrollTop: 0
                    }, 100);
                }
            }).catch((error)=> {
                console.debug(error.responseText);
            })

            return false;
        }
        formEnd.classList.add('was-validated');

    }

    //setting smartWisazrdForm
    smartWisazrdForm() {
        let opticForm =  $('#optic-form');


       /* это была проверка - если форма редактирования\копирования то можно из навигации переходить на любой шаг заполненной формы. с 19.01.2023 переход на любой шаг формы - по умолчани доступен и в новой форме, и в заполненной.
        let checkEditForm = $('#form-creation').attr('data-form-edit');
        let getJustifiedOption;
        if(checkEditForm === 'copy' || checkEditForm === 'edit'){
            getJustifiedOption = true
        } else {
            getJustifiedOption = false
        }
        console.debug(checkEditForm);
        */


        opticForm.smartWizard({
            enableUrlHash: false,
            justified: false,
            lang: {
                next: 'вперед',
                previous: 'назад'
            },
            anchor: {
                enableNavigation: true, // Enable/Disable anchor navigation
                enableNavigationAlways: true
                //enableNavigationAlways: getJustifiedOption, // см стр 1061
            },
            toolbar: {
                extraHtml: `
               <div class="form-buttons">
                    <div class="form-buttons__confirm">                    
                            <div class="btnTooltip__box">
                                <button class="btn btn-primary btn-lg" id="btnFinish" disabled data-action="click->form-creation#formConfirm" data-form-creation-save-param="save">Сохранить</button>
                                 <span class="btnTooltip">Сохраним и выйдем в список пациентов</span>
                            </div>
                        
                            <div class="btnTooltip__box"> 
                            <button class="btn btn-success btn-lg" id="btnFinishPrint" disabled data-action="click->form-creation#formConfirm" data-form-creation-save-param="saveprint">Сохранить и распечатать</button> 
                            <span class="btnTooltip">Сохраним и выйдем на страницу анкеты</span>  
                            </div>
                            
                    </div>
                    <div class="form-buttons__clear"> 
                        <button class="btn btn-danger" id="btnCancelModal" data-bs-toggle="modal" data-bs-target="#clearModal">Очистить анкету</button>
                        <div class="modal fade" id="clearModal" tabindex="-1" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Очистить анкету</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>                                        
                                    </div>
                                    <div class="modal-body">
                                    <p>Вы точно хотите очистить все поля этой анкеты?</p>
                                    <p>Если все поля будут пусты, вы не сможете сохранить анкету.</p>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Нет, не очищать анкету</button>
                                        <button type="button"  class="btn btn-danger" data-action="form-creation#formCancel" data-bs-dismiss="modal" id="btnCancel">очистить анкету</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
`
            },

        });


        // Leave step event is used for validating the forms
        opticForm.on("leaveStep", function(e, anchorObject, currentStepIdx, nextStepIdx, stepDirection) {
            // Validate only on forward movement
            if (stepDirection === 'forward') {
                let form = document.getElementById('form-step-' + (currentStepIdx + 1));

                let howFindValidation = $('.howFind-validation:checked').length;
                let visualLoadsValidation = $('.visualLoads-validation:checked').length;
                let improveVisionValidation = $('.improveVision-validation:checked').length;
                let preliminaryTestDistanseValidation = $('.preliminaryTestDistanse-validation:checked').length;

                let preliminaryTestNearValidation = $('.preliminaryTestNear-validation:checked').length;

                //let receiptGlassLensValidation = $('.receiptGlassLensValidation:checked').length;

                //   let receiptLensTypeValidation = $('.receiptLensTypeValidation:checked').length;

                if (howFindValidation === 0) {
                    $('.howFind-validation__box').addClass('valid-no');
                    $('input[name*="howFind"]').addClass('valid-no')
                }

                if (visualLoadsValidation === 0) {
                    $('.visualLoads-validation__box').addClass('valid-no');
                    $('input[name*="visualLoads"]').addClass('valid-no')
                }

                if (improveVisionValidation === 0) {
                    $('.improveVision-validation__box').addClass('valid-no');
                    $('input[name*="improveVision"]').addClass('valid-no')
                }

                if (preliminaryTestDistanseValidation === 0) {
                    $('.preliminaryTestDistanse-validation__box').addClass('valid-no');
                    $('input[class*="preliminaryTestDistanse-validation"]').addClass('valid-no')
                }

                if (preliminaryTestNearValidation === 0) {
                    $('.preliminaryTestNear-validation__box').addClass('valid-no');
                    $('input[class*="preliminaryTestNear-validation"]').addClass('valid-no')
                }

                if (form) {
                    if (!form.checkValidity() || howFindValidation === 0 || visualLoadsValidation === 0 || improveVisionValidation === 0 || preliminaryTestDistanseValidation === 0 || preliminaryTestNearValidation === 0 ) {
                        form.classList.add('was-validated');

                        opticForm.smartWizard("setState", [currentStepIdx], 'error');
                        opticForm.smartWizard('fixHeight');

                        $('body,html').animate({
                            scrollTop: 60
                        }, 100);

                        //if there is an error - a box with text
                        let currentForm = $('.was-validated').attr("id");
                        console.debug(currentForm);

                        //modal window with alarm
                        $('#'+currentForm).append('' +
                            '<div class="modal fade" id="currentFormError" tabindex="-1" aria-hidden="true">' +
                            '<div class="modal-dialog  modal-lg modal-dialog-centered ">' +
                            '<div class="modal-content">' +
                            '<div class="modal-body">' +
                            '<div class="alert alert-danger" role="alert">' +
                            '<p>Пожалуйста, заполните поля, отмеченные красным.</p>' +
                            '<p>Вы не сможете перейти на следующий шаг, пока не заполните все обязательные поля.</p></div>' +
                            '</div>' +
                            '<div class="modal-footer">\n' +
                            '<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Закрыть</button>\n' +
                            '</div>' +
                            '</div>' +
                            '</div>' +
                            '</div>')
                        const currentModalError = new Modal('#currentFormError');
                        currentModalError.show();
                        setTimeout(function(){
                            currentModalError.hide();
                        }, 10000);
                        return false;

                    }
                    opticForm.smartWizard("unsetState", [currentStepIdx], 'error');

                    $('body,html').animate({
                        scrollTop: 60
                    }, 100);
                }
            }

            if(stepDirection === 'backward'){
                $('body,html').animate({
                    scrollTop: 60
                }, 100);

            }


        });

        // Step show event
        opticForm.on("showStep", function(e, anchorObject, stepIndex, stepDirection, stepPosition) {

            $("#prev-btn").removeClass('disabled').prop('disabled', false);
            $("#next-btn").removeClass('disabled').prop('disabled', false);
            if(stepPosition === 'first') {
                $("#prev-btn").addClass('disabled').prop('disabled', true);
            } else if(stepPosition === 'last') {
                $("#next-btn").addClass('disabled').prop('disabled', true);
            } else {
                $("#prev-btn").removeClass('disabled').prop('disabled', false);
                $("#next-btn").removeClass('disabled').prop('disabled', false);
            }

            // Get step info from Smart Wizard
            let stepInfo = $('#optic-form').smartWizard("getStepInfo");
            $("#sw-current-step").text(stepInfo.currentStep + 1);
            $("#sw-total-step").text(stepInfo.totalSteps);

            if (stepPosition == 'last') {
                $("#btnFinish").prop('disabled', false);
                $("#btnFinishPrint").prop('disabled', false);
            } else {
                $("#btnFinish").prop('disabled', true);
                $("#btnFinishPrint").prop('disabled', true);
            }

        });

    }

    //checking checkboxes so that at least 1 is checked
    formCheckboxValidation(){
        /*
       first stage: to check when clicking on the input - in the formCheckboxValidation () method, we look for the necessary inputs and set the necessary classes for them

        second stage: to check in the step - in the smartWisazrdForm() method in the leaveStep function
            1. check if the number of checked checkboxes is not equal to zero
            2. when submitting the form, check if the number of checked checkboxes is not equal to zero
        */
        let checkboxBox;
        let findName;
        let min = 1;

        $('.checkboxvalid .form-check input').click(function( event ) {
            findName = $(this).attr('name').split("[]")[0];

            switch (findName) {
                case 'howFindUs':
                    checkboxBox = 'howFind-validation__box'
                    break;

                case 'visualLoadsList':
                    checkboxBox = 'visualLoads-validation__box'
                    break;

                case 'improveVisionList':
                    checkboxBox = 'improveVision-validation__box'
                    break;

                case 'preliminaryTestDistanse':
                    checkboxBox = 'preliminaryTestDistanse-validation__box'
                    break;

                case 'preliminaryTestNear':
                    checkboxBox = 'preliminaryTestNear-validation__box'
                    break;
            }

            if ($('input:checkbox[name="'+findName+'[]"]:checked').length >= min){
                $('.' + checkboxBox).removeClass('valid-no');
                $('.' + checkboxBox + ' input').removeClass('valid-no')
            } else {
                $('.' + checkboxBox).addClass('valid-no');
                $('.' + checkboxBox + ' input').addClass('valid-no')
            }

        });
    }

    //checking previous Glasses
    previousNoGlasses(){
        if($('#previousGlasses-noData').attr("checked", true)){
            $('.noGlass textarea, .noGlass select, .noGlass input').attr('disabled', true);
            $('.noGlass').addClass("disabled-box");
        }

        $('#previousGlassesList-box input[type=radio]').change(function() {
            if (this.value === 'noGlass' || this.value === 'noData') {
                $('.noGlass textarea, .noGlass select, .noGlass input').attr('disabled', true);
                $('.noGlass').addClass("disabled-box");
            }  else {
                $('.noGlass textarea, .noGlass select, .noGlass input').attr('disabled', false);
                $('.noGlass').removeClass("disabled-box");
            }
        });
    }

    //checking previous Lenses
    previousNoLens(){
        if($('#previousLensType-noData').attr("checked", true)){
            $('.noLens input').attr('disabled', true);
            $('.noLens').addClass("disabled-box");
        }
        $('#previousLensType-box input[type=radio]').change(function() {
            if (this.value === 'noLens' || this.value === 'noData') {
                $('.noLens input').attr('disabled', true);
                $('.noLens').addClass("disabled-box");
            }  else {
                $('.noLens input').attr('disabled', false);
                $('.noLens').removeClass("disabled-box");
            }

        });
    }

    //No lenses needed
    deleteMkl(){
        let inputFull = $('#contact-lens-delete');
        if (inputFull.is(':checked')){
            $('#contact-lens-delete-box input, #contact-lens-delete-box textarea').attr('disabled', true);
            $('#contact-lens-delete-box').addClass('disabled-box');
        } else {
            $('#contact-lens-delete-box input, #contact-lens-delete-box textarea').attr('disabled', false);
            $('#contact-lens-delete-box').removeClass('disabled-box');
        }
    }

    fullMobilityEyeballs(){
        let inputFull = $('#mobilityEyeballs-full');
        if (inputFull.is(':checked')){
            $('#fullMobilityEyeballs-descr input').attr('disabled', true);
            $('#fullMobilityEyeballs-descr').addClass('disabled-box');
        } else {
            $('#fullMobilityEyeballs-descr input').attr('disabled', false);
            $('#fullMobilityEyeballs-descr').removeClass('disabled-box');
        }
    }

    //consider the age of the patient
    clientAge(){
        let dateNow = new Date();
        dateNow = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
        let clientBirthday = $('#clientDateBirth').val();
        clientBirthday = clientBirthday.split(".");
        clientBirthday = new Date(clientBirthday[2], clientBirthday[1] - 1, clientBirthday[0]);
        clientBirthday = new Date(clientBirthday.getFullYear(), clientBirthday.getMonth(), clientBirthday.getDate());
        let clientBirthdayNow = new Date(dateNow.getFullYear(), clientBirthday.getMonth(), clientBirthday.getDate()); //Birthday in the current year

        let age;
        age = dateNow.getFullYear() - clientBirthday.getFullYear();
        if (dateNow < clientBirthdayNow) {
            age = age-1;
        }
        $('#clientAge').val(age);
    }

    //generating lists for selects with numbers
    sphList(){
        let step = 0.25;
        let sphListSelect = $('.sphList + datalist');
        for (let i = -20.25; i <= 11.75; i +=step) {
            let sphItem = i + step;
            sphListSelect.append('<option value="' + sphItem + '">');
        }
        step = 0.5;
        for (let i = 12; i <= 19.75; i +=step) {
            let sphItem = i + step;
            sphListSelect.append('<option value="' + sphItem + '">');
        }
        $('.sphList + datalist[value="0"]').prop('selected', true);
    }

    accommodationList(){
        let step = 0.25;
        let accommodationListSelect = $('.accommodationList + datalist');
        for (let i = -20.25; i <= 11.75; i +=step) {
            let accommodationItem = i + step;
            accommodationListSelect.append('<option value="' + accommodationItem + '">');
        }
    }

    cylList(){
        let step = 0.25;
        let cylListSelect = $('.cylList + datalist');
        for (let i = -12.25; i <= 11.75; i +=step) {
            let cylList = i + step;
            cylListSelect.append('<option value="' + cylList + '">' + cylList +'</option>')
        }
    }

    axList(){
        let axListSelect = $('.axList + datalist');
         for (let i = 0; i <= 180; i ++) {
             axListSelect.append('<option value="' + i + '">')
        }
    }

    girshbergList(){
        let girshbergListSelect = $('.girshbergList + datalist')
         for (let i = 0; i <= 50; i ++) {
             girshbergListSelect.append('<option value="' + i +'">' + i +'</option>')
        }
    }

    prList(){
        let step = 0.25;
        let prListSelect = $('.prList + datalist');
        for (let i = -0.25; i <= 19.75; i +=step) {
            let prList = i + step;
            prListSelect.append('<option value="' + prList + '">' + prList +'</option>')
        }
    }

    basList(){
        let step = 90;
        let basListSelect = $('.basList + datalist');
        for (let i = -90; i <= 180; i +=step) {
            let basList = i + step;
            basListSelect.append('<option value="' + basList + '">' + basList +'</option>')
        }
    }

    addList(){
        let step = 0.25;
        let addListSelect = $('.addList + datalist');
        for (let i = -0.25; i <= 4.75; i +=step) {
            let addList = i + step;
            addListSelect.append('<option value="' + addList + '">' + addList +'</option>')
        }
        /*$('.addList option[value=0]').prop('selected', true);*/
    }

    visList(){
        let vis = [0, 0.01, 0.02, 0.03, 0.04, 0.05, 0.06, 0.07, 0.08, 0.09, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.2, 1.5, 2.0];
        let visListSelect = $('.visList + datalist');
        vis.forEach(function (result){
            visListSelect.append('<option value="' + result + '">' + result +'</option>')
        })
    }

    visusList(){
        let step = 0.01;
        let visusListSelect = $('.visusList + datalist');
        for (let i = -0.01; i <= 1; i +=step) {
            let visusItem = (i + step).toFixed(2);
            visusListSelect.append('<option value="' + visusItem + '">' + visusItem +'</option>');
        }
        step = 0.1;
        for (let i = 1; i <= 2; i +=step) {
            let visusItem = (i + step).toFixed(1);
            visusListSelect.append('<option value="' + visusItem + '">' + visusItem +'</option>');
        }
    }

    correctionList(){
        let step = 0.01;
        let correctionListSelect = $('.correctionList + datalist');
        for (let i = -0.01; i <= 1; i +=step) {
            let correctionItem = (i + step).toFixed(2);
            correctionListSelect.append('<option value="' + correctionItem + '">' + correctionItem +'</option>');
        }
        step = 0.1;
        for (let i = 1; i <= 2; i +=step) {
            let correctionItem = (i + step).toFixed(1);
            correctionListSelect.append('<option value="' + correctionItem + '">' + correctionItem +'</option>');
        }
    }

    flexibilityList(){
        let flexibilityListSelect = $('.flexibilityList + datalist');
        for (let i = 0; i <= 15; i ++) {
            flexibilityListSelect.append('<option value="' + i + '">' + i +'</option>')
        }
    }

    additionOUList(){
        let step = 0.25;
        let additionalListSelect = $('.additionOUList + datalist');
        for (let i = -0.25; i <= 4.75; i +=step) {
            let additionOUList = i + step;
            additionalListSelect.append('<option value="' + additionOUList + '">' + additionOUList +'</option>')
        }
        /*$('.additionOUList option[value=0]').prop('selected', true);*/
    }

    keratometryList(){
        let step = 0.25;
        let keratometryListSelect = $('.keratometryList + datalist');
        for (let i = -10.25; i <= -0.25; i +=step) {
            let keratometryItem = (i + step).toFixed(2);
            keratometryListSelect.append('<option value="' + keratometryItem + '">' + keratometryItem +'</option>');
        }
    }

    symptomList(event){
        let nameId = event.target.id;
        let editFormCheck = $('#form-creation').attr('data-form');
            if ($('#' + nameId).is(':checked')){
                $('#' + nameId).attr('required', true);
                $('#' + nameId +' + input').attr('required', false).attr('checked', false);
                $('#' + nameId +'-list input').attr('required', true).attr('disabled', false);
            } else {
                $('#' + nameId).attr('required', false);
                $('#' + nameId +' + input').attr('required', true).attr('checked', true);
                $('#' + nameId +'-list input').attr('required', false).attr('disabled', true);
            }
    }

    receiptLensType(){
        if ($('#type-other').prop("checked") === true) {
            $('#receiptLens-other-box').removeClass('disabled-box');
            $('#type-other-description').attr('disabled', false).attr('required', true);
        } else {
            $('#receiptLens-other-box').addClass('disabled-box');
            $('#type-other-description').attr('disabled', true).attr('required', false);
        }
    }

    receiptGlassPr(event){
            let receiptGlassPrValues = false;
            $('.receiptGlassPr' + event.params.index).each(function (){
                   /* console.debug($(this).val());*/
                if($(this).val() == 0){
                    receiptGlassPrValues = true;
                }
            });
            if(receiptGlassPrValues){
                $('#footing-box'+ event.params.index).addClass('disabled-box');
                $('#footing-box'+ event.params.index +' input').attr('disabled', true).attr('required', false);
            } else {
                $('#footing-box'+ event.params.index).removeClass('disabled-box');
                $('#footing-box'+ event.params.index +' input').attr('disabled', false).attr('required', true);
            }
    }

    addNewReceiptGlass(){
        this.receiptGlassCounter++;
        $('#addNewReceiptGlassBox').append('' +
            '<div class="col-sm-12 mt-3 newReceiptGlassBox" id="newReceiptGlassBox'+ this.receiptGlassCounter +'">' +
            '<button type="button" class="btn btn-danger newReceiptGlassBtn" data-action="click->form-creation#deleteNewReceiptGlass" data-form-creation-del-param="newReceiptGlassBox'+ this.receiptGlassCounter +'" >Удалить</button>' +
            '<strong>Рецепт на очки #'+ ((this.receiptGlassCounter)+1 )+' </strong>' +
            ' \n' +
            '                        <div class="col-sm-6 mt-3">\n' +
            '                            <table class="table table-bordered vision-table">\n' +
            '                                <thead>\n' +
            '                                    <tr>\n' +
            '                                        <th></th>\n' +
            '                                        <th>OD</th>\n' +
            '                                        <th>OS</th>\n' +
            '                                    </tr>\n' +
            '                                </thead>\n' +
            '                                <tbody>\n' +
            '                                    <tr>\n' +
            '                                        <td><div class="vision-table-title">Visus <br><span class="form-text">без коррекции</span></div></td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control" id="receiptGlass'+ this.receiptGlassCounter +'OD-visus-before" type="number" value="0" step="0.01" min="-20" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OD][visus][before]"  autocomplete="off" />\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control" id="receiptGlass'+ this.receiptGlassCounter +'OS-visus-before" type="number" value="0" step="0.01" min="-20" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OS][visus][before]"  autocomplete="off" />\n' +
            '                                        </td>\n' +
            '                                    </tr>\n' +
            '                                </tbody>\n' +
            '                            </table>\n' +
            '                        </div>\n' +
            '\n' +
            '                       \n' +
            '                        <div class="col-sm-12 mt-3">\n' +
            '                            <table class="table table-bordered vision-table">\n' +
            '                                <thead>\n' +
            '                                    <tr>\n' +
            '                                        <th class=""></th>\n' +
            '                                        <th class="vision-table-bg">sph</th>\n' +
            '                                        <th class="vision-table-bg">cyl</th>\n' +
            '                                        <th class="vision-table-bg">ax</th>\n' +
            '                                        <th class="vision-table-bg">Add</th>\n' +
            '                                        <th class="vision-table-bg">pr1</th>\n' +
            '                                        <th class="vision-table-bg">bas</th>\n' +
            '                                        <th class="vision-table-bg">pr2</th>\n' +
            '                                        <th class="vision-table-bg">bas</th>\n' +
            '                                    </tr>\n' +
            '                                </thead>\n' +
            '                                <tbody>\n' +
            '                                    <tr>\n' +
            '                                        <td><div class="vision-table-title">OD</div></td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control sphList" list="receiptGlass'+ this.receiptGlassCounter +'OD-sph" type="number" value="0" step="0.01" min="-20" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OD][sph]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OD-sph"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control cylList" list="receiptGlass'+ this.receiptGlassCounter +'OD-cyl" type="number" value="0" step="0.01"  min="-12" max="12" name="receiptGlass['+ this.receiptGlassCounter +'][OD][cyl]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OD-cyl"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control axList" list="receiptGlass'+ this.receiptGlassCounter +'OD-ax" type="number" value="0" step="0.01"  min="0" max="180" name="receiptGlass['+ this.receiptGlassCounter +'][OD][ax]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OD-ax"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control addList" list="receiptGlass'+ this.receiptGlassCounter +'OD-add" type="number" value="0" step="0.01"  min="0" max="5.0" name="receiptGlass['+ this.receiptGlassCounter +'][OD][add]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OD-add"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control prList receiptGlassPr'+ this.receiptGlassCounter +'" list="receiptGlass'+ this.receiptGlassCounter +'OD-pr1" type="number" value="0" step="0.01"  min="0" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OD][pr1]" autocomplete="off" required=""  data-action="change->form-creation#receiptGlassPr" data-form-creation-index-param="'+ this.receiptGlassCounter +'" data-form-creation-id-param="'+ this.receiptGlassCounter +'"/>\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OD-pr1"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control basList" list="receiptGlass'+ this.receiptGlassCounter +'OD-bas1" type="number" value="0" step="0.01"  min="0" max="270" name="receiptGlass['+ this.receiptGlassCounter +'][OD][bas1]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OD-bas1"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control prList receiptGlassPr'+ this.receiptGlassCounter +'" list="receiptGlass'+ this.receiptGlassCounter +'OD-pr2" type="number" value="0" step="0.01"  min="0" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OD][pr2]"  autocomplete="off" required="" data-action="change->form-creation#receiptGlassPr" data-form-creation-index-param="'+ this.receiptGlassCounter +'" data-form-creation-id-param="'+ this.receiptGlassCounter +'" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OD-pr2"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control basList" list="receiptGlass'+ this.receiptGlassCounter +'OD-bas2" type="number" value="0" step="0.01"  min="0" max="270" name="receiptGlass['+ this.receiptGlassCounter +'][OD][bas2]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OD-bas2"></datalist>\n' +
            '                                        </td>\n' +
            '                                    </tr>\n' +
            '                                    <tr>\n' +
            '                                        <td><div class="vision-table-title">OS</div></td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control sphList" list="receiptGlass'+ this.receiptGlassCounter +'OS-sph" type="number" value="0" step="0.01" min="-20" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OS][sph]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OS-sph"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control cylList" list="receiptGlass'+ this.receiptGlassCounter +'OS-cyl" type="number" value="0" step="0.01"  min="-12" max="12" name="receiptGlass['+ this.receiptGlassCounter +'][OS][cyl]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OS-cyl"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control axList" list="receiptGlass'+ this.receiptGlassCounter +'OS-ax" type="number" value="0" step="0.01"  min="0" max="180" name="receiptGlass['+ this.receiptGlassCounter +'][OS][ax]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OS-ax"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control addList" list="receiptGlass'+ this.receiptGlassCounter +'OS-add" type="number" value="0" step="0.01"  min="0" max="5.0" name="receiptGlass['+ this.receiptGlassCounter +'][OS][add]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OS-add"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control prList receiptGlassPr'+ this.receiptGlassCounter +'" list="receiptGlass'+ this.receiptGlassCounter +'OS-pr1" type="number" value="0" step="0.01"  min="0" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OS][pr1]"  autocomplete="off" required="" data-action="change->form-creation#receiptGlassPr" data-form-creation-index-param="'+ this.receiptGlassCounter +'" data-form-creation-id-param="'+ this.receiptGlassCounter +'" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OS-pr1"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control basList" list="receiptGlass'+ this.receiptGlassCounter +'OS-bas1" type="number" value="0" step="0.01"  min="0" max="270" name="receiptGlass['+ this.receiptGlassCounter +'][OS][bas1]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OS-bas1"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control prList receiptGlassPr'+ this.receiptGlassCounter +'" list="receiptGlass'+ this.receiptGlassCounter +'OS-pr2" type="number" value="0" step="0.01"  min="0" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OS][pr2]"  autocomplete="off" required="" data-action="change->form-creation#receiptGlassPr" data-form-creation-index-param="'+ this.receiptGlassCounter +'" data-form-creation-id-param="'+ this.receiptGlassCounter +'" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OS-pr2"></datalist>\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control basList" list="receiptGlass'+ this.receiptGlassCounter +'OS-bas2" type="number" value="0" step="0.01"  min="0" max="270" name="receiptGlass['+ this.receiptGlassCounter +'][OS][bas2]"  autocomplete="off" required="" />\n' +
            '                                            <datalist id="receiptGlass'+ this.receiptGlassCounter +'OS-bas2"></datalist>\n' +
            '                                        </td>\n' +
            '                                    </tr>\n' +
            '                                </tbody>\n' +
            '                            </table>\n' +
            '                        </div>\n' +
            '\n' +
            '                      \n' +
            '                        <div class="col-sm-6 mt-3">\n' +
            '                            <table class="table table-bordered vision-table">\n' +
            '                                <thead>\n' +
            '                                    <tr>\n' +
            '                                        <th></th>\n' +
            '                                        <th>OD</th>\n' +
            '                                        <th>OS</th>\n' +
            '                                    </tr>\n' +
            '                                </thead>\n' +
            '                                <tbody>\n' +
            '                                    <tr>\n' +
            '                                        <td><div class="vision-table-title">Visus <br><span class="form-text">после коррекции</span></div></td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control" id="receiptGlass'+ this.receiptGlassCounter +'OD-visus-after" type="number" value="0" step="0.01" min="-20" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OD][visus][after]"  autocomplete="off" />\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control" id="receiptGlass'+ this.receiptGlassCounter +'OD-visus-after" type="number" value="0" step="0.01" min="-20" max="20" name="receiptGlass['+ this.receiptGlassCounter +'][OS][visus][after]"  autocomplete="off" />\n' +
            '                                        </td>\n' +
            '                                    </tr>\n' +
            '                                </tbody>\n' +
            '                            </table>\n' +
            '                        </div>\n' +
            ' \n' +
            '                        <div class="col-sm-12 mt-3 disabled-box"  id="footing-box'+ this.receiptGlassCounter +'">\n' +
            '                            <div class="col-sm-6">\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="radio" value="bi" class="form-check-input" name="receiptGlass['+ this.receiptGlassCounter +'][footing]" id="footing'+ this.receiptGlassCounter +'-bi" disabled >\n' +
            '                                    <label class="form-check-label" for="footing'+ this.receiptGlassCounter +'-bi">BI (основание внутрь)</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="radio" value="bo" class="form-check-input" name="receiptGlass['+ this.receiptGlassCounter +'][footing]" id="footing'+ this.receiptGlassCounter +'-bo" disabled >\n' +
            '                                    <label class="form-check-label" for="footing'+ this.receiptGlassCounter +'-bo">BO (основание к виску)</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="radio" value="bu" class="form-check-input" name="receiptGlass['+ this.receiptGlassCounter +'][footing]" id="footing'+ this.receiptGlassCounter +'-bu" disabled >\n' +
            '                                    <label class="form-check-label" for="footing'+ this.receiptGlassCounter +'-bu">BU (основание вверх)</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="radio" value="bd" class="form-check-input" name="receiptGlass['+ this.receiptGlassCounter +'][footing]" id="footing'+ this.receiptGlassCounter +'-bd" disabled >\n' +
            '                                    <label class="form-check-label" for="footing'+ this.receiptGlassCounter +'-bd">BD (основание вниз)</label>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '\n' +
            '                    \n' +
            '                        <div class="col-sm-6 mt-3">\n' +
            '                            <table class="table table-bordered vision-table">\n' +
            '                                <thead>\n' +
            '                                    <tr>\n' +
            '                                        <th></th>\n' +
            '                                        <th>OD</th>\n' +
            '                                        <th>OS</th>\n' +
            '                                    </tr>\n' +
            '                                </thead>\n' +
            '                                <tbody>\n' +
            '                                    <tr>\n' +
            '                                        <td><div class="vision-table-title">РЦ даль</div></td>\n' +
            '\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control" id="receiptGlass'+ this.receiptGlassCounter +'OD-rc-distance" type="number" value="0" step="0.01" name="receiptGlass['+ this.receiptGlassCounter +'][OD][rc][distance]" autocomplete="off" />\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control" id="receiptGlass'+ this.receiptGlassCounter +'OS-rc-distance" type="number" value="0" step="0.01" name="receiptGlass['+ this.receiptGlassCounter +'][OS][rc][distance]" autocomplete="off" />\n' +
            '                                        </td>\n' +
            '                                    </tr>\n' +
            '                                    <tr>\n' +
            '                                        <td><div class="vision-table-title">РЦ близь</div></td>\n' +
            '\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control" id="receiptGlass'+ this.receiptGlassCounter +'OD-rc-near" type="number" value="0" step="0.01" name="receiptGlass['+ this.receiptGlassCounter +'][OD][rc][near]" autocomplete="off" />\n' +
            '                                        </td>\n' +
            '                                        <td>\n' +
            '                                            <input class="form-control" id="receiptGlass'+ this.receiptGlassCounter +'OS-rc-near" type="number" value="0" step="0.01" name="receiptGlass['+ this.receiptGlassCounter +'][OS][rc][near]" autocomplete="off" />\n' +
            '                                        </td>\n' +
            '                                    </tr>\n' +
            '                                </tbody>\n' +
            '                            </table>\n' +
            '                        </div>\n' +
            '\n' +
            '                      \n' +
            '                        <div class="row col-sm-12 mt-3 receiptGlassLensValidation__box">\n' +
            '                            <div class="col-sm-6 ">\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="checkbox" value="distanse" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ this.receiptGlassCounter +'][lenses][]" id="lenses-distanse'+ this.receiptGlassCounter +'"  >\n' +
            '                                    <label class="form-check-label" for="lenses-distanse'+ this.receiptGlassCounter +'">Даль</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="checkbox" value="reader" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ this.receiptGlassCounter +'][lenses][]" id="lenses-reader'+ this.receiptGlassCounter +'"  >\n' +
            '                                    <label class="form-check-label" for="lenses-reader'+ this.receiptGlassCounter +'">Близь</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="checkbox" value="constance" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ this.receiptGlassCounter +'][lenses][]" id="lenses-constance'+ this.receiptGlassCounter +'"  >\n' +
            '                                    <label class="form-check-label" for="lenses-constance'+ this.receiptGlassCounter +'">Постоянное ношение</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="checkbox" value="provision" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ this.receiptGlassCounter +'][lenses][]" id="lenses-provision'+ this.receiptGlassCounter +'"  >\n' +
            '                                    <label class="form-check-label" for="lenses-provision'+ this.receiptGlassCounter +'">Курс Provision</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                            </div>\n' +
            '                            <div class="col-sm-6">\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="checkbox" value="single" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ this.receiptGlassCounter +'][lenses][]" id="lenses-single'+ this.receiptGlassCounter +'" >\n' +
            '                                    <label class="form-check-label" for="lenses-single'+ this.receiptGlassCounter +'">Однофокальные</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="checkbox" value="progressive" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ this.receiptGlassCounter +'][lenses][]" id="lenses-progressive'+ this.receiptGlassCounter +'" >\n' +
            '                                    <label class="form-check-label" for="lenses-progressive'+ this.receiptGlassCounter +'">Прогрессивные</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="checkbox" value="bifocal" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ this.receiptGlassCounter +'][lenses][]" id="lenses-bifocal'+ this.receiptGlassCounter +'" >\n' +
            '                                    <label class="form-check-label" for="lenses-bifocal'+ this.receiptGlassCounter +'">Бифокальные</label>\n' +
            '                                </div>\n' +
            '\n' +
            '                                <div class="form-check">\n' +
            '                                    <input type="checkbox" value="office" class="form-check-input receiptGlassLensValidation" name="receiptGlass['+ this.receiptGlassCounter +'][lenses][]" id="lenses-office'+ this.receiptGlassCounter +'" >\n' +
            '                                    <label class="form-check-label" for="lenses-office'+ this.receiptGlassCounter +'">Офисные</label>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </div>' +
            '</div>');
        $('#addNewReceiptGlassBox input[type="text"],textarea,input[type="number"]').focus(function(){
            $(this).select();
        });
    }

    deleteNewReceiptGlass(even){
        let delItem = '#'+ even.params.del;
        $(delItem).remove();
    }

    checkboxesCheckSelected(){
        $( ".howFind-validation__box input" ).on( "click", function() {
            if ($(this).val() !== 'noData'){
                $('.howFind-validation__box input[value="noData"]').prop('checked', false)
            } else {
                $('.howFind-validation__box input').each(function() {
                    if($(this).val() !== 'noData'){
                        /*console.debug($(this).val());*/
                        $(this).prop('checked', false);
                    }
                })
            }
        });
        $( ".visualLoads-validation__box input" ).on( "click", function() {
            if ($(this).val() !== 'noData'){
                $('.visualLoads-validation__box input[value="noData"]').prop('checked', false)
            } else {
                $('.visualLoads-validation__box input').each(function() {
                    if($(this).val() !== 'noData'){
                        /*console.debug($(this).val());*/
                        $(this).prop('checked', false);
                    }
                })
            }
        });
        $( ".improveVision-validation__box input" ).on( "click", function() {
            if ($(this).val() !== 'noData'){
                $('.improveVision-validation__box input[value="noData"]').prop('checked', false)
            } else {
                $('.improveVision-validation__box input').each(function() {
                    if($(this).val() !== 'noData'){
                        /*  console.debug($(this).val());*/
                        $(this).prop('checked', false);
                    }
                })
            }
        });
        $( ".preliminaryTestDistanse-validation__box input" ).on( "click", function() {
            if ($(this).val() !== 'noData'){
                $('.preliminaryTestDistanse-validation__box input[value="noData"]').prop('checked', false)
            } else {
                $('.preliminaryTestDistanse-validation__box input').each(function() {
                    if($(this).val() !== 'noData'){
                        /* console.debug($(this).val());*/
                        $(this).prop('checked', false);
                    }
                })
            }
        });
        $( ".preliminaryTestNear-validation__box input" ).on( "click", function() {
            if ($(this).val() !== 'noData'){
                $('.preliminaryTestNear-validation__box input[value="noData"]').prop('checked', false)
            } else {
                $('.preliminaryTestNear-validation__box input').each(function() {
                    if($(this).val() !== 'noData'){
                        /* console.debug($(this).val());*/
                        $(this).prop('checked', false);
                    }
                })
            }
        });
    }

   async connect() {
       this.checkToken();

       let editFormCheck = $('#form-creation').attr('data-form');

        //we turn to twig, indicate which controller to use, inside we transfer the data
        let content = Twig.twig({ref: "form-creation"}).render({
            userAuth: this.WhoIs,
            editFormCheck: editFormCheck
        });

        //specify the block and display the contents of the twig in it
        $('#form-creation').html(content);

        //smartWizard plugin settings
        this.smartWisazrdForm();

        //checking checkboxes so that at least 1 is checked
        this.formCheckboxValidation();

        //generating a list of values ​​for selects
        this.sphList();
        this.cylList();
        this.axList();
        this.prList();
        this.addList();
        this.visList();
        this.basList();
        this.girshbergList();
        this.visusList();
        this.correctionList();
        this.flexibilityList();
        this.additionOUList();
        this.keratometryList();
        this.accommodationList();
        this.nextAppointmentDateVal();

        //for date field
        let self = this;
        $.datetimepicker.setLocale('ru');
        $('#clientDateBirth').datetimepicker({
            timepicker:false,
            format:'d.m.Y',
            maxDate:'0',
            onChangeDateTime:  self.clientAge
        });

       $('#clientFirstRequest').datetimepicker({
           timepicker:false,
           format:'d.m.Y',
           maxDate:'0',
       });

       $('#nextAppointmentDate').datetimepicker({
           timepicker:false,
           format:'d.m.Y'
       });

       //date of first access - by default, the current date
       let clientFirstRequestCurrent = new Date().toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
       $('#clientFirstRequest').val(clientFirstRequestCurrent);

        //if marked that the previous points | µl no
        this.previousNoGlasses();
        this.previousNoLens();

       $('.phone-box').mask('+7 (000) 000-00-00');
       $('#accommodationResearch-ak').mask('0/0',{placeholder: "_/_"});

       //checkboxes - If something other than no data is selected, then the no data item is automatically disabled
      this.checkboxesCheckSelected();


      //find all checkboxes and radios with noData value,
       //its parent is assigned the class noDataBox
       const noDataCheckbox = $('input[type="checkbox"][value="noData"]').parent();
       noDataCheckbox.addClass('noDataBox');
       const noDataRadio = $('input[type="radio"][value="noData"]').parent();
       noDataRadio.addClass('noDataBox');

       //MCL is disabled by default
       let inputFull = $('#contact-lens-delete');
       if (inputFull.is(':checked')){
           $('#contact-lens-delete-box input, #contact-lens-delete-box textarea').attr('disabled', true);
           $('#contact-lens-delete-box').addClass('disabled-box');
       }


       let formPatientId = $('#form-creation').attr('data-form');
       let patientId = $('#form-creation').attr('data-patientid');
       let datafromSchedule = $('#form-creation').attr('data-fromSchedule');
       if(formPatientId !== undefined && patientId !== undefined) {
           await this.fillForm();
                 this.editForm();
       } else if (formPatientId !== undefined){
           await this.fillForm();
           this.copyForm();
       }
       if (datafromSchedule){
           this.addFromSchedule();
       }


       $('input[type="text"],textarea,input[type="number"]').focus(function(){
           $(this).select();
       });
    }
}